import { styled } from '@linaria/react';
// intl-next Link не совместим с linaria. Не критично, при необходимости стилизовать дочерений <a> вместо Link
// eslint-disable-next-line no-restricted-imports
import Link from 'next/link';

import { P } from '~components/Typography';
import { hoverable } from '~theme/snippets';

export const Container = styled.header`
	position: sticky;
	top: 0;
	right: 0;
	width: 100%;
	z-index: 1;
	background: var(--color-black-06);
	backdrop-filter: blur(10px);
`;
export const ContainerInner = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 auto;
	padding: 0 var(--screen-padding);
	width: 100%;
	max-width: 1680px;
	height: var(--header-height);

	@media screen and (max-width: 768px) {
		padding: 0 16px;
	}
`;

export const SideContainer = styled.div<{ nogap?: boolean }>`
	display: flex;
	gap: ${({ nogap }) => (nogap ? 'none' : '24px')};
	align-items: center;

	@media screen and (max-width: 1024px) {
		gap: ${({ nogap }) => (nogap ? 'none' : '12px')};
	}
`;

export const Nav = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;

	@media screen and (max-width: 1024px) {
		gap: 12px;
	}

	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const Separator = styled.div<{ visible?: boolean }>`
	width: 1px;
	height: 16px;
	background: var(--color-white-02);
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;

export const HeaderButtonDataContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--color-white-01);
	border-radius: 32px;
	transition: background-color 0.2s;
`;

export const HeaderButtonContainer = styled.div<{ hoverable?: boolean }>`
	${hoverable};

	display: flex;
	align-items: center;
	justify-content: center;
	column-gap: 5px;
	padding: 8px 10px;
	cursor: ${({ hoverable }) => (hoverable ? 'pointer' : 'default')};

	@media screen and (max-width: 1024px) {
		padding: 8px;
	}

	@media (pointer: fine) {
		&:hover ${HeaderButtonDataContainer} {
			background-color: ${({ hoverable }) =>
				hoverable ? 'var(--color-white-02)' : 'var(--color-white-01)'};
		}
	}
`;

export const HeaderButtonText = styled(P)`
	@media screen and (max-width: 1365px) {
		display: none;
	}
`;

export const StyledLink = styled(Link)`
	display: flex;
	gap: 16px;
	align-items: center;
`;

export const DesktopWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;

	@media screen and (max-width: 1023px) {
		display: none;
	}
`;

export const MobileWrapper = styled.div`
	@media screen and (min-width: 1024px) {
		display: none;
	}
`;
